import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export interface MiningLandSummary {
  landId: string;
  userId: string;
  landType: string;
  xSize: number;
  ySize: number;
  zSize: number;
  generation: number;
  paidReset: boolean;
  createdAt: string;
  updatedAt: string;
}

interface UseMiningLandsReturn {
  lands: MiningLandSummary[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useMiningLands(): UseMiningLandsReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.mining.lands(),
    queryFn: async () => {
      const { data } = await api.get<{ lands: MiningLandSummary[] }>('/arches/mining/lands');
      return data;
    },
  });

  return {
    lands: data?.lands ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load mining lands' : null,
    refresh: () => {
      refetch();
    },
  };
}
